var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "buy-credits__vue-slider" },
    [
      _c(
        "vue-slider",
        _vm._b(
          {
            attrs: {
              marks: _vm.sliderMarks,
              "process-style": {
                background: "linear-gradient(90deg, #00B5FF 0%, #007EFF 100%)"
              }
            },
            on: {
              change: function($event) {
                return _vm.stepToCredits(_vm.step)
              }
            },
            model: {
              value: _vm.step,
              callback: function($$v) {
                _vm.step = $$v
              },
              expression: "step"
            }
          },
          "vue-slider",
          _vm.options,
          false
        ),
        [
          _c(
            "div",
            { staticClass: "buy-credits__saveindicators" },
            _vm._l(_vm.saveindicators, function(
              saveindicator,
              $saveindicatorIndex
            ) {
              return _c(
                "div",
                {
                  key: $saveindicatorIndex,
                  staticClass: "buy-credits__saveindicator"
                },
                [
                  _c("div", { staticClass: "buy-credits__range" }, [
                    _c("span", [
                      saveindicator
                        ? _c("span", { staticClass: "buy-credits__porcent" }, [
                            _vm._v(
                              _vm._s(_vm.$t("buyCredits.discount")) +
                                " " +
                                _vm._s(saveindicator) +
                                "% "
                            )
                          ])
                        : _vm._e()
                    ])
                  ])
                ]
              )
            }),
            0
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }